'use client';

import React, { useEffect, useRef } from 'react';

const items = [
  {
    val: 'Voice',
    desc: 'Cold calling is the core of every engagement. Your reps dial verified numbers inside proven calling windows, because a live conversation with a decision-maker outperforms every other channel.',
  },
  {
    val: 'Signals',
    desc: 'We watch funding rounds, hiring moves, leadership changes, and tech shifts across your market, score them weekly, and point your reps at accounts showing intent right now.',
  },
  {
    val: 'Email + LinkedIn',
    desc: 'Supporting touches that warm the call and follow the conversation, run on carefully managed sending practices that protect your company\'s reputation.',
  },
  {
    val: 'The SLA',
    desc: 'A written definition of a qualified meeting sits in your contract, with a per-meeting fee set in your agreement. We are paid when real meetings happen.',
  },
  {
    val: 'Reporting',
    desc: 'A weekly full-funnel report: dials, conversations, replies, meetings booked and held, and the rate your closers accept them as qualified.',
  },
  {
    val: 'Your team',
    desc: 'Named, dedicated, full-time reps who work for you only. Start with one, add more as the pipeline proves out. No pooled seats, ever.',
  },
];

export default function SystemSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-navy">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">What you get</div>
          <h2 className="heading-2 text-white">
            Reps are the delivery mechanism.<br />
            The system is the product.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items?.map((item, i) => (
            <div
              key={item?.val}
              className="rev bg-navy-panel border border-line-navy rounded-brand p-6"
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              <b className="font-display text-[44px] text-primary block leading-none font-bold mb-2.5">
                {item?.val}
              </b>
              <span className="text-[13.5px] text-muted-cream block leading-relaxed">
                {item?.desc}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}